module.exports = __webpack_public_path__ + "static/media/passapp_lockuptagline_es.be801a14.png";